export default {
  inputPlaceholder: {
    id: 'shopping_assistant_input_placeholder',
    defaultMessage: 'Ask Back Market AI…',
  },
  sendMessage: {
    id: 'shopping_assistant_send_message_button',
    defaultMessage: 'Send message',
  },
  emittedFromMe: {
    id: 'shopping_assistant_emitted_from_me_alternative_text',
    defaultMessage: 'I say:',
  },
  emittedFromAssistant: {
    id: 'shopping_assistant_emitted_from_assistant_alternative_text',
    defaultMessage: 'Assistant says:',
  },
  promptSuggestionsTitle: {
    id: 'shopping_assistant_prompt_suggestions_title',
    defaultMessage: 'Suggested prompts',
  },
} as const
